import React, { useState, useEffect } from "react";
import Alertas from "./Alertas";
import { auth } from "../firebase/firebaseConfig";
import {
  Container,
  Segment,
  Header,
  Form,
  Input,
  Button,
  Icon,
  Message,
} from "semantic-ui-react";
import { useNavigate, useParams } from "react-router-dom";
import useObtenerItems from "../hooks/useObtenerItems.js";
import ActualizarPrecioDB from "../firebase/ActualizarPrecioItems.js";

const ActualizaItemsTest = () => {
  const user = auth.currentUser;
  const navigate = useNavigate();
  const { id } = useParams();
  const [items] = useObtenerItems(id);

  const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
  const [alerta, cambiarAlerta] = useState({});
  const [categoria, setCategoria] = useState("");
  const [price, setPrice] = useState("");
  const [nombre, setNombre] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const volver = () => {
    navigate("/serviciotecnico/itemsst");
  };

  useEffect(() => {
    if (items) {
      setNombre(items.nombre || "");
      setPrice(
        items.price !== undefined && items.price !== null
          ? String(items.price)
          : ""
      );
      setCategoria(items.categoria || "");
    } else {
      navigate("/");
    }
  }, [items, navigate]);

  const permitePrecio =
    categoria === "REPUESTO" || categoria === "SERVICIO";

  const handleSubmit = async (e) => {
    e.preventDefault();

    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    if (!permitePrecio) {
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Esta categoría no permite actualización de precio.",
      });
      return;
    }

    if (price === "") {
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "Por favor ingrese un precio.",
      });
      return;
    }

    const precioNumerico = Number(price);

    if (
      !Number.isFinite(precioNumerico) ||
      precioNumerico <= 0
    ) {
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Por favor ingrese un precio válido mayor a cero.",
      });
      return;
    }

    if (!user?.email) {
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "No se pudo identificar al usuario.",
      });
      return;
    }

    setIsSaving(true);

    try {
      await ActualizarPrecioDB({
        id,
        precio: precioNumerico,
        userMod: user.email,
        fechaMod: new Date(),
      });

      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "exito",
        mensaje: "Precio actualizado correctamente.",
      });
    } catch (error) {
      console.error("Error al actualizar precio:", error);

      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje:
          error?.message ||
          "No fue posible actualizar el precio.",
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Container
      fluid
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        padding: "24px 12px 40px",
      }}
    >
      <Container
        fluid
        style={{
          maxWidth: 1000,
          margin: "0 auto",
        }}
      >
        {/* CABECERA */}
        <Segment
          style={{
            border: "1px solid #e2e8f0",
            borderRadius: 12,
            boxShadow: "0 4px 14px rgba(15,23,42,.05)",
            padding: "18px 20px",
            marginBottom: 16,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 10,
                background: "#ecfdf5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon
                name="edit outline"
                color="teal"
                size="large"
                style={{ margin: 0 }}
              />
            </div>

            <div
              style={{
                flex: 1,
                minWidth: 220,
              }}
            >
              <Header
                as="h2"
                style={{
                  margin: 0,
                  color: "#0f172a",
                }}
              >
                Actualizar Ítem ST

                <Header.Subheader
                  style={{
                    marginTop: 5,
                  }}
                >
                  Actualiza el precio del ítem seleccionado.
                </Header.Subheader>
              </Header>
            </div>

            <Button
              basic
              type="button"
              onClick={volver}
              disabled={isSaving}
            >
              <Icon name="arrow left" />
              Volver
            </Button>
          </div>
        </Segment>

        {/* FORMULARIO */}
        <Segment
          style={{
            border: "2px solid #00b5ad",
            borderRadius: 12,
            boxShadow:
              "0 0 0 1px rgba(0,181,173,.08), 0 4px 14px rgba(15,23,42,.05)",
          }}
        >
          <Header
            as="h3"
            style={{
              color: "#0f172a",
              marginBottom: 20,
            }}
          >
            <Icon
              name="dollar sign"
              color="teal"
            />

            <Header.Content>
              Actualización de precio

              <Header.Subheader>
                El nombre y la categoría del ítem no se
                modifican desde esta pantalla.
              </Header.Subheader>
            </Header.Content>
          </Header>

          {!permitePrecio && categoria && (
            <Message
              info
              icon="info circle"
              header="Ítem sin precio editable"
              content={`La categoría ${categoria} no utiliza precio. Sólo REPUESTO y SERVICIO permiten actualizar este valor.`}
            />
          )}

          <Form
            size="small"
            onSubmit={handleSubmit}
          >
            <Form.Group
              widths="equal"
              stackable
            >
              {/* ITEM */}
              <Form.Field>
                <label>Ítem</label>

                <Input
                  fluid
                  value={nombre}
                  disabled
                  icon={{
                    name: "tag",
                    color: "teal",
                  }}
                  iconPosition="left"
                />
              </Form.Field>

              {/* CATEGORÍA */}
              <Form.Field>
                <label>Categoría</label>

                <Input
                  fluid
                  value={categoria}
                  disabled
                  icon={{
                    name: "list",
                    color: "teal",
                  }}
                  iconPosition="left"
                />
              </Form.Field>

              {/* PRECIO */}
              <Form.Field>
                <label>Precio</label>

                <Input
                  fluid
                  type="text"
                  inputMode="numeric"
                  placeholder={
                    permitePrecio
                      ? "Ingrese Precio"
                      : "No aplica"
                  }
                  value={
                    permitePrecio
                      ? price
                      : ""
                  }
                  disabled={
                    !permitePrecio || isSaving
                  }
                  icon={{
                    name: "dollar sign",
                    color: permitePrecio
                      ? "teal"
                      : "grey",
                  }}
                  iconPosition="left"
                  onChange={(e) => {
                    const value = e.target.value;

                    if (
                      value === "" ||
                      /^[1-9]\d*$/.test(value)
                    ) {
                      setPrice(value);

                      cambiarEstadoAlerta(false);
                      cambiarAlerta({});
                      return;
                    }

                    cambiarEstadoAlerta(true);
                    cambiarAlerta({
                      tipo: "error",
                      mensaje:
                        "Por favor ingrese un número positivo.",
                    });
                  }}
                />
              </Form.Field>
            </Form.Group>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                flexWrap: "wrap",
                marginTop: 12,
              }}
            >
              <Button
                type="button"
                basic
                onClick={volver}
                disabled={isSaving}
              >
                <Icon name="arrow left" />
                Volver
              </Button>

              <Button
                color="teal"
                type="submit"
                loading={isSaving}
                disabled={
                  isSaving || !permitePrecio
                }
              >
                <Icon name="save" />
                Actualizar precio
              </Button>
            </div>
          </Form>
        </Segment>

        {/* ALERTAS */}
        <Alertas
          tipo={alerta.tipo}
          mensaje={alerta.mensaje}
          estadoAlerta={estadoAlerta}
          cambiarEstadoAlerta={cambiarEstadoAlerta}
        />
      </Container>
    </Container>
  );
};

export default ActualizaItemsTest;